import {Component} from 'san';

import styles from './style/index.module.less';

export default class RelatedNews extends Component {
    static template = require('./index.html');
    initData() {
        return {
            styles
        };
    }
    attached() {
        this.storeDispatch('relatedNews:showLog');
    }
    clickHandler(event, index) {
        this.storeDispatch('relatedNews:clkLog', {pos: index});
    }
};
